export { LayoutCMSComponent as LayoutCMS } from "./component";
import './_style.scss';


// WEBPACK FOOTER //
// ./src/components/templates/layout/index.tsx